<template>
  <div>
    <FullDialog
      dense
      :dialog="calendarDialog"
      v-on:close="calendarDialog = false"
      :back-route="{ name: 'admin.dashboard' }"
    >
      <template v-slot:title>
        <v-toolbar height="44" flat class="bg-transparent py-0">
          <v-flex class="my-auto">
            <!--  <v-menu bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  class="mr-5 font-level-3-bold d-inline-block --text fw-600"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ resourceType }}
                  <v-icon color="">mdi-menu-down</v-icon>
                </div>
              </template>
<v-list style="min-width: 200px">
  <v-list-item @click="changeModule('Visit')" class="border-bottom">
    <v-list-item-title>Visit</v-list-item-title>
  </v-list-item>
  <v-list-item @click="changeModule('Delivery')">
    <v-list-item-title>Delivery</v-list-item-title>
  </v-list-item>
</v-list>
</v-menu> -->
            <v-btn
              color="cyan white--text"
              tile
              depressed
              class="mr-1 rounded"
              v-on:click="getToday(), getEvents()"
            >
              Today
            </v-btn>
            <v-btn
              color="cyan white--text"
              tile
              depressed
              small
              outlined
              width="30"
              min-width="30"
              height="26"
              class="mr-1 rounded"
              v-on:click="preview(), getEvents()"
            >
              <v-icon>mdi-menu-left</v-icon>
            </v-btn>
            <v-btn
              color="cyan white--text"
              tile
              depressed
              small
              outlined
              width="30"
              min-width="30"
              height="26"
              class="mr-1 rounded"
              v-on:click="next(), getEvents()"
            >
              <v-icon>mdi-menu-right</v-icon>
            </v-btn>
            <div
              class="mx-5 font-level-3-bold d-inline-block cyan--text fw-600"
              style="min-width: 150px; font-size: 18px"
            >
              {{ toolbarTitle }}
            </div>
          </v-flex>
          <v-flex class="d-flex justify-content-start align-items-center">
            <div
              class="mx-5 font-level-3-bold d-inline-block cyan--text fw-600"
              style=""
            >
              Filters
            </div>
            <v-flex class="mr-2" v-if="false">
              <DatePicker
                outlined
                depressed
                hide-details
                placeholder="Select Date"
                class-name="mt-0"
                v-model="datefilter"
                v-on:change="getEvents"
              >
              </DatePicker>
            </v-flex>
            <v-flex class="mr-2">
              <v-autocomplete
                :items="typeList"
                v-model="job_type"
                hide-details
                clearable
                flat
                solo
                dense
                label="Job Type"
                v-on:change="getVisitList('ussigned')"
                color="cyan"
                item-color="cyan"
                class="pt-0 mt-0"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-action class="mr-0">
                    <v-chip
                      style="height: 16px !important; width: 16px; padding: 0"
                      :color="item.color"
                    >
                    </v-chip>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-capitalize font-weight-500 font-size-16"
                      >{{ item.text }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex class="mr-2" v-if="false">
              <v-autocomplete
                :items="statusList"
                v-model="status"
                hide-details
                clearable
                flat
                solo
                dense
                placeholder="Select Status"
                color="blue darken-4"
                item-color="blue darken-4"
                item-text="text"
                item-value="status"
                max-width="230px"
                min-height="26px"
                height="26px"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-action class="mr-0">
                    <v-chip
                      style="height: 16px !important; width: 16px; padding: 0"
                      :color="item.color"
                    >
                    </v-chip>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title
                      class="text-capitalize font-weight-500 font-size-16"
                      >{{ item.text }}</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action
                    class="align-self-center"
                    v-if="status == item.status"
                  >
                    <v-icon color="cyan">mdi-check</v-icon>
                  </v-list-item-action>
                </template>
              </v-autocomplete>
            </v-flex>
            <v-flex class="mr-2">
              <v-autocomplete
                :items="customerList"
                v-model="customer"
                hide-details
                clearable
                flat
                solo
                dense
                placeholder="Select Customer"
                color="blue darken-4"
                item-color="blue darken-4"
                item-text="display_name"
                item-value="id"
                v-on:change="getVisitList('ussigned')"
              >
              </v-autocomplete>
            </v-flex>
            <v-flex class="mr-2">
              <v-autocomplete
                :items="engineerList"
                v-model="engineer"
                hide-details
                clearable
                flat
                solo
                dense
                placeholder="Select Technician"
                color="blue darken-4"
                item-color="blue darken-4"
                item-text="display_name"
                item-value="id"
                v-on:change="filterTechnician"
              >
              </v-autocomplete>
            </v-flex>
          </v-flex>
          <v-flex class="d-flex justify-content-end">
            <v-btn
              color="cyan white--text"
              tile
              depressed
              class="mr-1 rounded"
              v-on:click="dayView()"
              :outlined="currentView != 'resourceTimelineDay'"
            >
              Day
            </v-btn>
            <v-btn
              color="cyan white--text"
              tile
              depressed
              class="mr-1 rounded"
              v-on:click="weekView()"
              :outlined="currentView != 'resourceTimelineWeek'"
            >
              Week
            </v-btn>
            <v-btn
              v-if="false"
              color="cyan white--text"
              tile
              depressed
              class="mr-1 rounded"
              v-on:click="monthView()"
              :outlined="currentView != 'resourceTimelineMonth'"
            >
              Month
            </v-btn>
            <v-btn
              depressed
              tile
              outlined
              color="cyan"
              class="white--text ml-1 rounded"
              :to="{ name: 'admin.calendar' }"
            >
              Calendar
            </v-btn>
            <v-btn
              outlined
              width="30"
              min-width="30"
              height="26"
              color="grey darken-4"
              class="white--text ml-3 rounded"
              @click="toggleVisit = !toggleVisit"
            >
              <v-icon size="20">{{
                toggleVisit
                  ? "mdi-format-indent-increase"
                  : "mdi-format-indent-decrease"
              }}</v-icon>
            </v-btn>
          </v-flex>
        </v-toolbar>
      </template>
      <template v-slot:body>
        <div class="resource-calendar-container">
          <div class="resource-calender d-flex">
            <div class="calender-wrapper">
              <FullCalendar ref="fullCalendar" :options="calendarOptions" />
              <div
                class="legends d-flex flex-wrap align-center justify-content-start my-2"
              >
                <!-- <div
                  class="px-2 mr-3 py-1 d-flex align-center"
                  v-for="(row, index) in [
                    { text: 'New', color: 'cyan' },
                    { text: 'In-Progress', color: 'orange' },
                    { text: 'Overdue', color: 'red' },
                  ]"
                  :key="index"
                  :style="`border-color:${row.color};`"
                >
                  <v-icon size="15" :color="row.color" class="mr-1"
                    >mdi-circle</v-icon
                  >
                  <span class="text-black">{{ row.text }}</span>
                </div> -->
              </div>
            </div>
            <div class="sidebar-event" v-show="toggleVisit">
              <div class="listing-contents">
                <div class="position-sticky px-3 mb-3">
                  <div class="d-flex py-1">
                    <h5
                      class="my-auto py-0 pl-2"
                      style="border-color: #a3a3a3 !important"
                    >
                      {{ filterType }}
                    </h5>
                    <v-menu offset-y v-if="false">
                      <template v-slot:activator="{ on, attrs }">
                        <h5
                          class="my-auto py-0 pl-2 cursor-pointer"
                          style="border-color: #a3a3a3 !important"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ filterType }}
                          <!-- <v-icon size="28">mdi-menu-down</v-icon> -->
                        </h5>
                      </template>
                      <v-list>
                        <v-list-item-group color="primary">
                          <v-list-item
                            link
                            @click="filterType = 'Assigned Visit'"
                            v-on:change="getVisitList('assigned')"
                          >
                            <v-list-item-title
                              class="fw-600 d-flex align-center"
                            >
                              <!--  <span
                          class="white--text mr-2 rounded-circle green d-flex justify-center align-center"
                          style="height: 22px; width: 22px"
                          >23</span
                        > -->
                              Assigned Visit</v-list-item-title
                            >
                          </v-list-item>
                          <v-list-item
                            link
                            @click="filterType = 'UnAssigned Visit'"
                            v-on:change="getVisitList('ussigned')"
                          >
                            <v-list-item-title
                              class="fw-600 d-flex align-center"
                            >
                              <!-- <span
                          class="white--text mr-2 rounded-circle blue d-flex justify-center align-center"
                          style="height: 22px; width: 22px"
                          >23</span
                        > -->
                              UnAssigned Visit</v-list-item-title
                            >
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-menu>
                  </div>
                  <div class="mb-2">
                    <DateRangePicker
                      v-model="visitDateRange"
                      placeholder="Visit Date Range"
                      :nudge-left="200"
                      v-on:update:model-value="getVisitList('ussigned')"
                      v-on:click:clear="clearVisitDateRange"
                    ></DateRangePicker>
                  </div>
                </div>
                <v-flex class="mb-3 px-3 white" v-if="false">
                  <v-autocomplete
                    :items="engineerList"
                    v-model="engineer"
                    hide-details
                    clearable
                    flat
                    solo
                    dense
                    prepend-inner-icon="mdi-magnify"
                    placeholder="Select Engineer"
                    color="blue darken-4"
                    item-color="blue darken-4"
                    item-text="display_name"
                    item-value="id"
                    class="pa-0"
                  >
                    <!-- <template v-slot:selection="{ item, index }">
                <span v-if="index === 0" class="text-truncate d-inline-block">{{
                  item.display_name
                }}</span>
                <span v-if="index === 1" class="ml-2 grey--text text-caption">
                  (+{{ engineer.length - 1 }} more)
                </span>
              </template> -->
                    <template v-slot:item="{ item }">
                      <v-list-item-avatar
                        class="mr-1"
                        height="30"
                        width="30"
                        min-width="30"
                        color="grey lighten-2 grey--text"
                      >
                        <span class="fw-500">
                          {{ item.display_name.slice(0, 2).toUpperCase() }}
                        </span>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-capitalize font-weight-500 font-size-16"
                          >{{ item.display_name }}</v-list-item-title
                        >
                      </v-list-item-content>
                      <v-list-item-action
                        class="align-self-center"
                        v-if="engineer == item.id"
                      >
                        <v-icon color="cyan">mdi-check</v-icon>
                      </v-list-item-action>
                    </template>
                  </v-autocomplete>
                </v-flex>

                <div
                  class="px-3"
                  id="external-draggable"
                  style="height: 82vh; overflow-y: auto; overflow-x: hidden;"
                >
                  <div
                    class="list-items fc-event border"
                    v-for="item in visit_list"
                    :key="item.id"
                    :data-set="JSON.stringify(item)"
                    :style="`background-color: ${getBgColor(item.status)}`"
                  >
                    <div
                      class="d-flex justify-content-between align-items-center"
                    >
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <span
                            class="fw-700 blue--text text-darken-4"
                            style="font-size: 16px"
                            v-bind="attrs"
                            v-on="on"
                            >#{{ item.barcode }}</span
                          >
                        </template>
                        <div class="text-left pa-2">
                          <div class="font-weight-bold mb-1" v-if="item.title">
                            {{ item.title }}
                          </div>
                          <div v-if="item.barcode" class="mb-1">
                            <strong>Visit:</strong> #{{ item.barcode }}
                          </div>
                       
                          <div class="mb-1" v-if="item.started_at">
                            <v-icon small dark class="mr-1"
                              >mdi-clock-outline</v-icon
                            >
                            {{ formatDate(item.started_at) }}
                            {{ formatDateStartTime(item.started_at) }}
                            <template v-if="item.finished_at">
                              to {{ formatDate(item.finished_at) }}
                              {{ formatDateStartTime(item.finished_at) }}
                            </template>
                          </div>
                          
                          <div
                            v-if="
                              item.customer &&
                              (item.customer.display_name ||
                                item.customer.company_name)
                            "
                            class="mb-1"
                          >
                            <v-icon small dark class="mr-1">mdi-domain</v-icon>
                            {{
                              item.customer.display_name ||
                              item.customer.company_name
                            }}
                          </div>
                         
                          <div
                            v-if="
                              item.ticket_calendar &&
                              item.ticket_calendar.priority_text
                            "
                            class="mb-1"
                          >
                            <v-icon small dark class="mr-1"
                              >mdi-alert-circle-outline</v-icon
                            >
                            Priority: {{ item.ticket_calendar.priority_text }}
                          </div>

                          <div
                            v-if="item.status_text"
                            class="mt-2 pt-2"
                            style="
                              border-top: 1px solid rgba(255, 255, 255, 0.2);
                            "
                          >
                            Status: {{ item.status_text }}
                          </div>
                        </div>
                      </v-tooltip>
                      <div>
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="visit-date d-flex align-items-center mr-2"
                              v-on="on"
                              v-bind="attrs"
                            >
                              <v-icon
                                size="13"
                                color="green darken-4"
                                class="mr-1"
                                >mdi-alarm</v-icon
                              >
                              <span class="green--text fw-500 font-size-11"
                                >{{ formatDate(item.started_at) }}

                                {{ formatDateStartTime(item.started_at) }}</span
                              >
                            </div>
                          </template>
                          <span>Start date</span>
                        </v-tooltip>
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              class="visit-date d-flex align-items-center mr-2"
                              v-on="on"
                              v-bind="attrs"
                            >
                              <v-icon
                                size="13"
                                color="red darken-4"
                                class="mr-1"
                                >mdi-alarm</v-icon
                              >
                              <span class="red--text fw-500 font-size-11"
                                >{{ formatDate(item.finished_at) }}

                                {{
                                  formatDateStartTime(item.finished_at)
                                }}</span
                              >
                            </div>
                          </template>
                          <span>End date</span>
                        </v-tooltip>
                      </div>
                    </div>
                    <div class="d-flex">
                      <div class="flex-grow-1">
                        <div class="visit-title">
                          <span
                            class="text-truncate d-block fw-500"
                            style="font-size: 13px; max-width: 200px"
                            >{{ item.title }}</span
                          >
                        </div>
                        <!--                         <div class="">
                          <span style="color: #63636c"
                            >abc -1235 758468568 jhj4144 565658 Singapore</span
                          >
                        </div> -->
                      </div>
                      <div class="action-side">
                        <div>
                          <v-icon
                            size="18"
                            class=""
                            :color="
                              getPriorityColor(
                                item.ticket_calendar.priority_text
                              )
                            "
                          >
                            mdi-circle
                          </v-icon>
                        </div>
                        <!-- <div>
                    <v-icon size="18" class="my-1"> mdi-flag</v-icon>
                  </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </FullDialog>
    <Dialog :common-dialog="confirm_dialog" :dialog-width="dialogWidth">
      <template v-slot:title> Confirmation </template>
      <template v-slot:body>
        <v-form ref="statusForm" v-model.trim="formValid" lazy-validation>
          <v-container class="px-10 text-center" fluid>
            <p class="font-weight-600 font-size-19">
              Are you sure, you want to
              <span class="font-weight-700">
                rescheduling or reassigning Visit
                {{ dataInfo?.event?.extendedProps?.visitBarcode }}</span
              >?
            </p>
          </v-container>
        </v-form>
      </template>
      <template v-slot:action>
        <v-btn
          depressed
          :disabled="confirm_loading"
          v-on:click="closeConfirmDialog()"
          class="mx-2 custom-grey-border custom-bold-button"
        >
          No! Close
        </v-btn>
        <v-btn
          depressed
          v-on:click="confirm_submit()"
          :disabled="!formValid || confirm_loading"
          :loading="confirm_loading"
          class="mx-2 custom-bold-button white--text"
          color="cyan"
        >
          Yes! Continue
        </v-btn>
      </template>
    </Dialog>

    <!-- Leave Detail Dialog — visit-style UI -->
    <Dialog :common-dialog="viewLeaveDialog" :dialog-width="680">
      <template v-slot:title>
        <v-layout v-if="leaveDetail">
          <!-- Left: barcode + status -->
          <v-flex md6 class="d-flex align-center">
            <h1 class="form-title custom-nowrap-ellipsis text-capitalize mb-0">
              Leave #{{ leaveDetail.leaveBarcode }}
            </h1>
          </v-flex>

          <!-- Right: action buttons -->
          <v-flex md6 class="d-flex justify-end align-center">
            <v-btn
              v-if="!showLeaveRemarkField"
              depressed
              color="red"
              class="mx-1 custom-bold-button white--text"
              :disabled="leaveActionLoading"
              small
              v-on:click="showLeaveRemarkField = true"
            >
              <v-icon left small>mdi-close-circle-outline</v-icon>
              Reject Leave
            </v-btn>
            <v-btn
              v-else
              depressed
              color="red darken-2"
              class="mx-1 custom-bold-button white--text"
              :disabled="leaveActionLoading || !leaveRemark.trim()"
              :loading="leaveActionLoading"
              small
              v-on:click="disapproveLeave()"
            >
              <v-icon left small>mdi-close-circle</v-icon>
              Confirm Rejection
            </v-btn>

            <v-btn
              v-if="leaveDetail && leaveDetail.leaveStatus != 2"
              depressed
              color="green darken-1"
              class="mx-1 custom-bold-button white--text"
              :disabled="leaveActionLoading"
              :loading="leaveActionLoading"
              small
              v-on:click="approveLeave()"
            >
              <v-icon left small>mdi-check-circle-outline</v-icon>
              Approve
            </v-btn>

            <v-btn
              depressed
              :disabled="leaveActionLoading"
              class="ml-2 custom-grey-border custom-bold-button"
              small
              v-on:click="viewLeaveDialog = false"
            >
              Close
            </v-btn>
          </v-flex>
        </v-layout>
      </template>

      <template v-slot:body>
        <v-container v-if="leaveDetail">
          <v-row>
            <!-- Left white column -->
            <v-col cols="5" class="pb-0">
              <span
                class="color-custom-blue font-weight-700 font-size-20 d-block mb-3"
              >
                {{ leaveDetail.category || "—" }}
              </span>
              <v-layout class="my-2">
                <v-flex md12>
                  <table width="100%">
                    <tr>
                      <td class="font-weight-600 py-1">Leave ID</td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-500 py-0">
                        {{ leaveDetail.leaveBarcode }}
                      </td>
                    </tr>
                    <tr>
                      <td class="font-weight-600 py-1 pt-3">Reason</td>
                    </tr>
                    <tr>
                      <td class="font-size-18 font-weight-500 py-0">
                        {{ leaveDetail.reason || "—" }}
                      </td>
                    </tr>
                  </table>
                </v-flex>
              </v-layout>
            </v-col>

            <!-- Right gray column -->
            <v-col md="7" class="pb-0 gray-background pl-4">
              <v-container fluid>
                <v-row dense>
                  <v-col md="12">
                    <v-chip
                      class="my-2 font-weight-600"
                      color="chip-custom-blue"
                      label
                      outlined
                    >
                      {{
                        leaveDetail.leaveStatus == 2
                          ? "Approved Leave"
                          : "Pending Leave"
                      }}
                    </v-chip>
                    <table class="width-100">
                      <tr>
                        <td class="font-size-18 py-1" width="160">Category</td>
                        <td class="font-weight-600 font-size-18 py-1">
                          {{ leaveDetail.category || "—" }}
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1" width="160">From</td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span style="color: #24326d !important">{{
                            leaveDetail.startDate
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1" width="160">To</td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <span style="color: #24326d !important">{{
                            leaveDetail.endDate
                          }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-size-18 py-1" width="160">Status</td>
                        <td class="font-weight-600 font-size-18 py-1">
                          <v-chip
                            small
                            :color="leaveStatusConfig.color"
                            :text-color="leaveStatusConfig.textColor"
                            class="ml-3 font-weight-600"
                            label
                          >
                            <v-icon left x-small>
                              {{ leaveStatusConfig.icon }}
                            </v-icon>
                            {{ leaveStatusConfig.label }}
                          </v-chip>
                        </td>
                      </tr>
                    </table>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>

          <!-- Remark field — shown when Disapprove is clicked -->
          <v-expand-transition>
            <v-row v-if="showLeaveRemarkField" class="mt-2">
              <v-col cols="12">
                <v-divider class="mb-3"></v-divider>
                <p
                  class="font-weight-600 red--text text--darken-2 mb-2 font-size-16"
                >
                  <v-icon small color="red darken-2" class="mr-1"
                    >mdi-alert-circle-outline</v-icon
                  >
                  Please enter a remark for rejection:
                </p>
                <v-textarea
                  v-model="leaveRemark"
                  outlined
                  dense
                  rows="3"
                  autofocus
                  hide-details="auto"
                  placeholder="Enter reason for rejection..."
                  color="red darken-2"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-container>
      </template>
    </Dialog>

    <DetailDrawer
      :drawer="open_detail"
      v-on:close="open_detail = false"
    ></DetailDrawer>
    <SingleVisitDetail
      v-if="viewVisitDialog"
      :visit-dialog="viewVisitDialog"
      :visit="visitId"
      type="resource"
      v-on:close="viewVisitDialog = false"
      v-on:reload="onVisitReload"
      v-on:reload-calendar="onVisitReload"
    >
    </SingleVisitDetail>
  </div>
</template>
<script>
import DetailDrawer from "@/view/pages/calendar/DetailDrawer";
import FullCalendar from "@fullcalendar/vue";
/* import APIService from "@/core/services/api.service"; */
import dayGridPlugin from "@fullcalendar/daygrid";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import SingleVisitDetail from "@/view/pages/job/partials/Single-Visit-Detail.vue";
import DatePicker from "@/view/components/DatePicker";
import DateRangePicker from "@/view/components/DateRangePicker.vue";
//import ObjectPath from "object-path";
import { toSafeInteger } from "lodash";
/* import ObjectPath from "object-path"; */

import moment from "moment-timezone";
import CommonMixin from "@/core/plugins/common-mixin";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import { QUERY, PATCH } from "@/core/services/store/request.module";
import APIService from "@/core/services/api.service";
import FullDialog from "@/view/components/FullDialog2.vue";
import Dialog from "@/view/pages/partials/Dialog";
import {
  SuccessEventBus,
  ErrorEventBus,
  InitializeError,
} from "@/core/lib/message.lib";

export default {
  mixins: [CommonMixin],
  name: "Resource-calender",
  props: {
    teamResourceCalendar: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FullDialog,
    FullCalendar,
    DetailDrawer,
    SingleVisitDetail,
    DatePicker,
    DateRangePicker,
    Dialog,
  },
  data() {
    return {
      resourceType: "Visit",
      calendarDialog: true,
      confirm_loading: false,
      confirm_dialog: false,
      formValid: true,
      draggableEvent: null,
      toggleVisit: true,
      filterType: "UnAssigned Visit",
      calendarFilterType: "Assigned Visit",
      count: 0,
      open_detail: false,
      job_type: null,
      visitDateRange: [],
      dataInfo: null,
      typeList: [
        {
          text: "One Off Job",
          value: "ono_off",
          color: "red lighten-1",
        },
        {
          text: "Recurring Job",
          value: "recurring",
          color: "green lighten-1",
        },
      ],
      allData: {},
      payload_data: null,
      status: "0",
      visitId: 0,
      customer: "0",
      event_lists: [],
      viewVisitDialog: false,
      viewLeaveDialog: false,
      leaveDetail: null,
      leaveRemark: "",
      showLeaveRemarkField: false,
      leaveActionLoading: false,
      engineers: "0",
      toolbarTitle: null,
      calendarDateObject: {},
      engineer: 0,
      currentView: "resourceTimelineDay",
      labelFormat: [{ hour: "numeric" }],
      calendarOptions: {
        schedulerLicenseKey: "GPL-My-Project-Is-Open-Source",
        plugins: [resourceTimelinePlugin, interactionPlugin, dayGridPlugin],
        headerToolbar: {
          left: "prev,next",
          center: "title",
          right:
            "resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth",
        },
        timeZone: process.env.VUE_APP_TIMEZONE,
        initialView: "resourceTimelineDay",
        slotLabelFormat: this.labelFormat,
        slotLabelContent: this.formatLabel,
        aspectRatio: 1.8,
        resourceAreaWidth: "300px",
        editable: true,
        droppable: true,
        eventOverlap: false,
        eventClick: this.handleEventClick,
        resourceLabelDidMount: this.mountResourceLabel,
        eventDidMount: this.mountEventData,
        eventWillUnmount: this.unmountEventData,
        eventReceive: this.customEventReceive,
        drop: this.dropFunction,
        eventDrop: this.eventDrop,
        eventResize: this.eventResize,
        resourceAreaHeaderContent: {
          html: '<div class="text-left mb-1"><b>Engineers</b></div></div>',
        },
        resourceAreaHeaderClassNames: "engineers-search",
        resources: [],
        events: this.getEvents,
        fixedMirrorParent: document.body,
      },
      resource_name: [],
      visit_list: [],
      statusList: [],
      customerList: [],
      datefilter: null,
      engineerList: [],
    };
  },
  methods: {
    next() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.next();
      this.toolbarTitle = calendarApi.view.title;
    },
    changeModule(type) {
      this.resourceType = type;
      if (type == "Visit") {
        this.getVisitList("ussigned");
        this.getEvents();
        this.getResource();
      } else {
        this.getVisitList("ussigned");
        this.getEvents();
        this.getResource();
      }
    },

    approveLeave() {
      if (!this.leaveDetail || !this.leaveDetail.leaveId) return;
      this.leaveActionLoading = true;
      APIService.patch(`leave/${this.leaveDetail.leaveId}/approved`)
        .then(() => {
          SuccessEventBus.$emit(
            "update:success",
            `Leave ${this.leaveDetail.leaveBarcode} has been approved successfully.`
          );
          this.viewLeaveDialog = false;
          this.leaveRemark = "";
          this.showLeaveRemarkField = false;
          this.leaveDetail = null;
          this.$refs.fullCalendar.getApi().refetchEvents();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.leaveActionLoading = false;
        });
    },

    disapproveLeave() {
      if (!this.leaveDetail || !this.leaveDetail.leaveId) return;
      if (!this.leaveRemark.trim()) return;
      this.leaveActionLoading = true;
      APIService.patch(`leave/${this.leaveDetail.leaveId}/rejected`, {
        remark: this.leaveRemark,
      })
        .then(() => {
          SuccessEventBus.$emit(
            "update:success",
            `Leave ${this.leaveDetail.leaveBarcode} has been rejected.`
          );
          this.viewLeaveDialog = false;
          this.leaveRemark = "";
          this.showLeaveRemarkField = false;
          this.leaveDetail = null;
          this.$refs.fullCalendar.getApi().refetchEvents();
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.leaveActionLoading = false;
        });
    },
    formatDateStartTime(row) {
      return moment(row).format("hh:mm A");
    },
    preview() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.prev();
      this.toolbarTitle = calendarApi.view.title;
    },
    getToday() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.today();
      this.toolbarTitle = calendarApi.view.title;
    },
    dayView() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.changeView("resourceTimelineDay");
      this.toolbarTitle = calendarApi.view.title;
      this.currentView = calendarApi.view.type;
      this.calendarOptions.slotLabelFormat = [{ hour: "numeric" }];
    },
    weekView() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.changeView("resourceTimelineWeek");
      this.toolbarTitle = calendarApi.view.title;
      this.currentView = calendarApi.view.type;
      this.calendarOptions.slotLabelFormat = [
        { day: "2-digit", weekday: "long", week: "long" },
        { hour: "numeric" },
      ];
    },
    monthView() {
      let calendarApi = this.$refs.fullCalendar.getApi();
      calendarApi.changeView("resourceTimelineMonth");
      this.toolbarTitle = calendarApi.view.title;
      this.currentView = calendarApi.view.type;
      this.calendarOptions.slotLabelFormat = [
        { week: "long" },
        { day: "2-digit", weekday: "short" },
      ];
    },
    initFilter() {
      APIService.query("resource-calendar/filters")
        .then(({ data }) => {
          this.customerList = data.customers;
          this.engineerList = data.engineers;
          this.statusList = data.statuses;
        })
        .catch((error) => {
          this.logError(error);
        });
    },
    filterTechnician() {
      if (this.$refs.fullCalendar) {
        this.$refs.fullCalendar.getApi().refetchEvents();
      }
    },
    formatLabel(el) {
      const weekDayArr = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
      const d = new Date(el.date);
      const weekDay = d.getDay();
      const DayDate = d.getDate();
      if (el.view.type == "resourceTimelineMonth" && el.level == 1) {
        return {
          html: `
          <div class="text-center ${
            weekDay == 0 || weekDay == 6 ? "grey--text text--darken-4" : ""
          }">
            <div>${weekDayArr[weekDay]}</div>
            <div class="bt-day">${DayDate}</div>
          </div>
          `,
        };
      }
    },

    mountEventData(info) {
      this.mountEventTooltip(info);
      this.$nextTick(() => {
        const extended = info.event._def.extendedProps;
        if (extended.visitId != undefined) {
          let infoElement = document.createElement("div");
          const startTime = /* extended.startDate; */ moment(
            extended.startDate,
            "YYYY-MM-DD h:mm:ss"
          ).format("LT");
          const endTime = /* extended.endDate;  */ moment(
            extended.endDate,
            "YYYY-MM-DD h:mm:ss"
          ).format("LT");

          const bt_elem = `<div class="d-flex">
                <div class="pl-1" style="color:#333;white-space: nowrap;">
                  <b>${info.event.title}</b>
                  <div>
                  <span> ${startTime} - ${endTime}</span>
                </div>
                  <!-- <div class="time text-truncate" style="font-size:16px;color:#333">Globex Corporation</div> 
                  <div class="event-type px-2 ${info.event._def.extendedProps.bg_color} darken-3 rounded d-inline-block">${info.event._def.extendedProps.eventType}</div>-->
                </div>
              </div>`;
          infoElement.innerHTML = bt_elem; //info.event._def.extendedProps.visitId;
          infoElement.classList.add("fc-event-id");
          let elementNode = info.el.querySelector(".fc-event-title-container");
          elementNode.prepend(infoElement);
        }

        // ── Leave background events ──────────────────────────────────────────
        if (extended.isLeave) {
          const leaveEl = document.createElement("div");
          leaveEl.classList.add("leave-bg-label", "text-center");
          leaveEl.innerHTML = `
            <span class="leave-bg-barcode text-black">
              ${extended.leaveBarcode || ""}
            </span></br>
            ${
              extended.reason
                ? `<span class="leave-bg-reason text-black">${extended.reason}</span>`
                : ""
            }
          `;

          if (info && info.el) {
            info.el.classList.remove("fc", "fc-bg-event");
            const parentBg = info.el.closest && info.el.closest(".fc-bg-event");
            if (parentBg) parentBg.classList.remove("fc", "fc-bg-event");
          }

          info.el.appendChild(leaveEl);
        }
      });
    },
    mountEventTooltip(info) {
      const extended = info.event.extendedProps || {};

      // Leave events are rendered as background events and do not have visit details.
      if (!extended.visitId || !info.el) return;

      const tooltip = document.createElement("div");
      tooltip.className = "resource-calendar-event-tooltip";
      tooltip.setAttribute("role", "tooltip");

      const addRow = (label, value, icon, className) => {
        if (!value) return;
        const row = document.createElement("div");
        row.className = className || "resource-calendar-event-tooltip__row mb-1";
        if (icon) {
          const iconElement = document.createElement("i");
          iconElement.className = `v-icon notranslate mdi ${icon} theme--dark mr-1`;
          row.appendChild(iconElement);
        }
        if (label) {
          const labelElement = document.createElement("strong");
          labelElement.textContent = `${label}: `;
          row.appendChild(labelElement);
        }
        row.appendChild(document.createTextNode(String(value)));
        tooltip.appendChild(row);
      };

      const customer =
        extended.customer && typeof extended.customer === "object"
          ? extended.customer
          : {};
      const customerName =
        customer.display_name ||
        customer.company_name ||
        (typeof extended.customer === "string" ? extended.customer : "") ||
        extended.customerName ||
        extended.customer_name ||
        (this.customerList.find((item) => Number(item.id) === Number(extended.customer)) || {})
          .display_name;
      const priority =
        (extended.ticket_calendar && extended.ticket_calendar.priority_text) ||
        extended.priority_text ||
        extended.priorityText ||
        {
          1: "High",
          2: "Medium",
          3: "Low",
        }[extended.ticket_priority];
      const status =
        extended.status_text ||
        extended.statusText ||
        (this.statusList.find(
          (item) => Number(item.value) === Number(extended.visitStaus)
        ) || {})
          .text ||
        {
          1: "Open",
          2: "In-Progress",
          3: "Hold",
          4: "Completed",
          5: "Cancelled",
          6: "Send",
        }[extended.visitStaus];
      const startDate = extended.startDate || info.event.start;
      const endDate = extended.endDate || info.event.end;
      const formatTooltipDate = (date) =>
        date ? moment(date).format("DD/MM/YYYY hh:mm A") : "";
      const timeRange = [formatTooltipDate(startDate), formatTooltipDate(endDate)]
        .filter(Boolean)
        .join(" to ");

      const visitNumber = extended.visitBarcode || extended.barcode;
      const title = document.createElement("div");
      title.className = "resource-calendar-event-tooltip__title";
      title.textContent = info.event.title || "Visit";
      tooltip.appendChild(title);
      addRow(
        "Visit",
        visitNumber
          ? `#${String(visitNumber).replace(/^#/, "")}`
          : info.event.title,
        null
      );
      addRow(null, timeRange, "mdi-clock-outline");
      addRow(null, customerName, "mdi-domain");
      if (priority) {
        addRow(null, `Priority: ${priority}`, "mdi-alert-circle-outline");
      }
      if (status) {
        addRow(
          null,
          `Status: ${status}`,
          null,
          "resource-calendar-event-tooltip__row resource-calendar-event-tooltip__status"
        );
      }

      document.body.appendChild(tooltip);

      const positionTooltip = () => {
        const rect = info.el.getBoundingClientRect();
        const tooltipRect = tooltip.getBoundingClientRect();
        const left = Math.min(
          Math.max(8, rect.left + (rect.width - tooltipRect.width) / 2),
          window.innerWidth - tooltipRect.width - 8
        );
        const top =
          rect.top - tooltipRect.height - 8 >= 8
            ? rect.top - tooltipRect.height - 8
            : rect.bottom + 8;

        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${Math.max(8, top)}px`;
      };
      const showTooltip = () => {
        tooltip.classList.add("is-visible");
        positionTooltip();
      };
      const hideTooltip = () => tooltip.classList.remove("is-visible");

      info.el.addEventListener("mouseenter", showTooltip);
      info.el.addEventListener("mousemove", positionTooltip);
      info.el.addEventListener("mouseleave", hideTooltip);
      info.el._resourceCalendarTooltipCleanup = () => {
        info.el.removeEventListener("mouseenter", showTooltip);
        info.el.removeEventListener("mousemove", positionTooltip);
        info.el.removeEventListener("mouseleave", hideTooltip);
        tooltip.remove();
      };
    },
    unmountEventData(info) {
      if (info.el && info.el._resourceCalendarTooltipCleanup) {
        info.el._resourceCalendarTooltipCleanup();
        delete info.el._resourceCalendarTooltipCleanup;
      }
    },
    confirm_submit() {
      this.allData = this.dataInfo;
      try {
        const old_resource =
          this.dataInfo &&
          this.dataInfo.oldResource &&
          this.dataInfo.oldResource._resource &&
          this.dataInfo.oldResource._resource.id;
        const new_resource =
          this.dataInfo &&
          this.dataInfo.event &&
          this.dataInfo.event._def &&
          this.dataInfo.event._def.resourceIds &&
          this.dataInfo.event._def.resourceIds[0]
            ? toSafeInteger(this.dataInfo.event._def.resourceIds[0])
            : 0;
        const is_all_day =
          this.dataInfo &&
          this.dataInfo.event &&
          this.dataInfo.event._def &&
          toSafeInteger(this.dataInfo.event._def.allDay);
        const params = {
          all_day: is_all_day,
          customer: this.dataInfo.event?.extendedProps?.customer,
          date: is_all_day ? this.dataInfo.event.startStr.substr(0, 19) : null,
          visit: this.dataInfo.event.extendedProps.visitId,
          engineer: new_resource,
          del_engineer: old_resource,
          started_at: is_all_day
            ? null
            : this.dataInfo.event.startStr.substr(0, 19),
          finished_at: is_all_day
            ? null
            : this.dataInfo.event.endStr.substr(0, 19),
        };

        if (!this.dataInfo.event._def.allDay && !this.dataInfo.event.end) {
          params.finished_at = moment(this.dataInfo.event.startStr)
            .add(1, "hour")
            .format("YYYY-MM-DDTHH:mm:ss");
        }
        this.confirm_loading = true;
        APIService.patch("resource-calendar/event-dropped", params)
          .then(() => {
            this.confirm_dialog = false;
            SuccessEventBus.$emit(
              "update:success",
              `Your visit ${this.dataInfo?.event?.extendedProps?.visitBarcode} has been successfully re-assigned and rescheduled.`
            );
            this.dataInfo = null;
          })
          .catch((error) => {
            this.closeConfirmDialog();
            this.logError(error);
          })
          .finally(() => {
            this.confirm_loading = false;
            this.onVisitReload();
          });
      } catch (error) {
        this.closeConfirmDialog();
        this.logError(error);
      }
    },
    closeConfirmDialog() {
      if (this.dataInfo && typeof this.dataInfo.revert === "function") {
        this.dataInfo.revert();
      }
      this.confirm_dialog = false;
      this.dataInfo = null;
    },
    eventDrop(info) {
      this.dataInfo = info;
      if (
        toSafeInteger(this.dataInfo?.event.extendedProps.visitStaus) == 1 ||
        toSafeInteger(this.dataInfo.event.extendedProps.visitStaus) == 2
      ) {
        this.confirm_dialog = true;
      } else {
        ErrorEventBus.$emit(
          "update:error",
          InitializeError(
            `Visit ${this.dataInfo?.event.extendedProps.visitBarcode} can only be reassigned and rescheduled when its status is 'Open' or 'In Progress'.`
          )
        );
        info.revert();
        this.dataInfo = null;
        return false;
      }
    },
    mountResourceLabel(info) {
      let profile_name = document.createElement("div");
      let profile_image = document.createElement("img");
      let total_count = document.createElement("div");

      profile_name.innerHTML =
        info.resource._resource.extendedProps.designation;
      const avatar = info.resource._resource.extendedProps.avatar;
      profile_image.setAttribute(
        "src",
        avatar ? avatar : "/media/default/no-profile-image.png"
      );

      if (info.resource._resource.extendedProps.child) {
        profile_image.setAttribute("class", "resource_user_image ml-5");
        profile_name.setAttribute(
          "class",
          "resource_user_designation font-size-13 pl-72"
        );
      } else {
        profile_image.setAttribute("class", "resource_user_image mr-3");
        profile_name.setAttribute(
          "class",
          "resource_user_designation font-size-13 pl-52"
        );
      }
      let elementNode = info.el.querySelector(".fc-datagrid-cell-cushion");
      elementNode.style.borderColor = `${info.resource._resource.extendedProps.status_color}`;
      elementNode.classList.add("h-100");
      elementNode.prepend(profile_image);
      elementNode.append(profile_name);
      elementNode.append(total_count);
    },

    customEventReceive() {},

    onVisitReload() {
      this.$nextTick(() => {
        if (this.$refs.fullCalendar) {
          this.$refs.fullCalendar.getApi().refetchEvents();
        }
        this.getVisitList("ussigned");
      });
    },

    getEvents(fetchInfo, successCallback) {
      let date = null;
      if (
        this.currentView &&
        this.currentView == "resourceTimelineWeek" &&
        this.toolbarTitle
      ) {
        date = moment(this.toolbarTitle, "MMM DD, YYYY");
      } else {
        date = this.toolbarTitle;
      }
      const params = {
        start:
          fetchInfo && fetchInfo.start
            ? moment(fetchInfo.start).format("YYYY-MM-DDTHH:mm")
            : moment(date).format("YYYY-MM-DDTHH:mm"),
        end:
          fetchInfo && fetchInfo.end
            ? moment(fetchInfo.end).format("YYYY-MM-DDTHH:mm")
            : moment(date).format("YYYY-MM-DDTHH:mm"),
        engineers: this.engineer,
        statuses: this.status,
        resourceType: this.resourceType,
        currentView: this.currentView,
        team_resource_calendar: this.teamResourceCalendar ? 1 : 0,
      };
      APIService.query("resource-calendar/events", params)
        .then(({ data }) => {
          const results = data.results || [];
          const leaves = data.leaves || [];

          const events = [];

          results.forEach((item) => {
            events.push(item);
          });

          leaves.forEach((leave) => {
            let bgColor = "#9e9e9e"; // default grey
            if (leave.classNames && leave.classNames.includes("red")) {
              bgColor = "#ef5350"; // approved → red
            } else if (
              leave.classNames &&
              leave.classNames.includes("orange")
            ) {
              bgColor = "#ff9800"; // pending → orange
            }

            events.push({
              resourceId: leave.resourceId,
              title: leave.title || "On Leave",
              start: leave.start,
              end: leave.end,
              display: "background",
              color: bgColor,
              classNames: leave.classNames || "leave-event",
              extendedProps: {
                ...leave,
                isLeave: true,
              },
            });
          });

          this.event_lists = events;

          if (typeof successCallback === "function") {
            successCallback(events);
          }
        })
        .catch((error) => {
          this.logError(error);
        });
    },

    eventResize(info) {
      this.eventDrop(info);
    },

    dropFunction(data) {
      const { resource, draggedEl } = data;
      const _this = this;
      const { dataset } = draggedEl;
      const visit = JSON.parse(dataset.set);
      _this.pageLoading = true;
      console.log({ data });

      const started_at = moment(data.dateStr, moment.ISO_8601).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      const finished_at = moment(data.dateStr, moment.ISO_8601)
        .add(1, "hour")
        .format("YYYY-MM-DD HH:mm:ss");

      _this.$store
        .dispatch(PATCH, {
          url: "assign-engineer-by-date",
          data: {
            started_at,
            finished_at,
            visit: visit.id,
            engineer: resource.id,
            customer: visit.customer?.id,
          },
        })
        .then(() => {})
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          this.onVisitReload();
          this.pageLoading = false;
        });
    },

    handleEventClick({ event }) {
      let events = event._def.extendedProps;
      // Leave background event → open leave detail dialog
      if (events.isLeave) {
        this.leaveDetail = events;
        this.viewLeaveDialog = true;
        return;
      }
      // Visit event → open visit detail dialog
      if (!events.visitId) return;
      this.visitId = toSafeInteger(events.visitId);
      this.viewVisitDialog = true;
    },
    getColor(data) {
      if (data == 1) {
        return "blue";
      } else if (data == 2) {
        return "purple";
      } else if (data == 3) {
        return "red";
      } else if (data == 4) {
        return "green";
      } else if (data == 5) {
        return "red";
      } else if (data == 6) {
        return "cyan";
      }
    },
    getPriorityColor(data) {
      if (data == "Low") {
        return "green";
      } else if (data == "Medium") {
        return "orange";
      } else if (data == "High") {
        return "red";
      }
    },
    getBgColor(data) {
      if (data == 1) {
        return "#E3F2FD  !important";
      } else if (data == 2) {
        return "#f9f9ce !important";
      } else if (data == 3) {
        return "#f3e6cb !important";
      } else if (data == 4) {
        return "#E8F5E9 !important";
      } else if (data == 5) {
        return "#FFEBEE !important;";
      } else if (data == 6) {
        return "#d9fffd !important";
      }
    },
    formatDateTimeStart(row) {
      return moment(row).format("hh:mm A");
    },
    formatetimedata(row) {
      return moment(row).format("hh:mm A");
    },
    getVisitList(type) {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "visit-list",
              data: {
                type: type,
                start_date:
                  this.visitDateRange && this.visitDateRange.length === 2
                    ? this.visitDateRange[0]
                    : null,
                end_date:
                  this.visitDateRange && this.visitDateRange.length === 2
                    ? this.visitDateRange[1]
                    : null,
                resourceType: this.resourceType,
                customer:
                  this.customer && Number(this.customer) > 0
                    ? this.customer
                    : null,
                job_type: this.job_type,
              },
            })
            .then(({ data }) => {
              this.visit_list = data;
              if (this.visit_list && this.visit_list.length) {
                setTimeout(this.dragableEvent, 200);
              }
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
    clearVisitDateRange() {
      this.visitDateRange = [];
      this.$nextTick(() => this.getVisitList("ussigned"));
    },
    dragableEvent() {
      const _this = this;

      const containerEl = document.getElementById("external-draggable");

      if (_this.draggableEvent) {
        _this.draggableEvent.destroy();
      }
      _this.$nextTick(() => {
        _this.draggableEvent = new Draggable(containerEl, {
          itemSelector: ".fc-event",
          eventData: function (eventEl) {
            const attribute = eventEl.dataset;
            if (attribute && attribute.event) {
              _this.payload_data = JSON.parse(attribute.event);
            }
            return {
              title: eventEl.innerText,
              create: false,
            };
          },
        });
      });
    },

    getCurrentDate() {
      let currentDate = this.$refs.fullCalendar.getApi();
      let newData = moment(currentDate.currentData.viewTitle).format(
        "YYYY-MM-DDTHH:mm"
      );
      let dateObject = { start: newData, end: newData };
      this.calendarDateObject = dateObject;
    },
    refetchEvents() {
      this.calendarOptions.refetchEvents();
    },
    removeAllEvents() {
      this.calendarOptions.removeAllEvents();
    },
    getResource() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(QUERY, {
              url: "resource-calendar/resources",
              data: {
                resourceType: this.resourceType ? this.resourceType : "Visit",
                team_resource_calendar: this.teamResourceCalendar ? 1 : 0,
              },
            })
            .then((data) => {
              this.resource_name = data;
              this.calendarOptions.resources = this.resource_name;
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  mounted() {
    let calendarApi = this.$refs.fullCalendar.getApi();
    this.toolbarTitle = calendarApi.view.title;
    this.getResource();
    this.getVisitList("ussigned");
    this.dragableEvent();
    this.initFilter();
    this.getCurrentDate();
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 40);
    },
    leaveStatusConfig() {
      const status = Number(this.leaveDetail?.leaveStatus ?? 0);
      switch (status) {
        case 2:
          return {
            color: "green lighten-4",
            textColor: "green darken-3",
            icon: "mdi-check-circle",
            label: "Approved",
          };
        case 1:
          return {
            color: "orange",
            textColor: "white darken-3",
            icon: "mdi-alert-circle",
            label: "Pending",
          };
        default:
          return {
            color: "red lighten-4",
            textColor: "red darken-3",
            icon: "mdi-clock-outline",
            label: "Pending",
          };
      }
    },
  },
};
</script>
<style>
.resource-calendar-event-tooltip {
  position: fixed;
  z-index: 9999;
  display: none;
  min-width: 220px;
  max-width: 350px;
  padding: 8px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.9);
  color: #fff;
  font-size: 14px;
  line-height: 1.4;
  pointer-events: none;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.3);
}

.resource-calendar-event-tooltip.is-visible {
  display: block;
}

.resource-calendar-event-tooltip__title {
  margin-bottom: 4px;
  font-weight: 700;
}

.resource-calendar-event-tooltip__row .v-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: text-bottom;
}

.resource-calendar-event-tooltip__status {
  margin-top: 8px !important;
  padding-top: 8px;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
}
</style>
<!-- <style scoped>
.fc-timeline-event-harness {
  min-width: 150px !important;
}
</style> -->
